import React, { useEffect } from 'react'
import { Route, Routes as RoutesWrapper, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

// routes middlewares
import PublicRoute from './PublicRoute'

// utils
import { PAGE } from '../utils/enums'
import Navigator from '../utils/navigation'

// layouts
import FormBuilderLayout from '../layouts/FormBuilderLayout'
import MainLayout from '../layouts/MainLayout'

import AuthRoute from './AuthRoute'

// reducers
import { getBeVersions, getIframeVersions } from '../reducers/versions/versionActions'

// pages
import FormBuilderPage from '../pages/FormBuilderPage/FormBuilderPage'
import FormSettingsPage from '../pages/FormSettingsPage/FormSettingsPage'
import NotFoundPage from '../pages/ErrorPages/NotFoundPage'
import LoginPage from '../pages/LoginPage/LoginPage'
import FormDocsPage from '../pages/FormsPage/FormDocsPage'
import UsersPage from '../pages/UsersPage/UsersPage'
import TemplatesPage from '../pages/TemplatesPage/TemplatesPage'
import TemplateSettingsPage from '../pages/TemplateSettingsPage/TemplateSettingsPage'
import PreviewPage from '../pages/PreviewPage/PreviewPage'

const AppRoutes = () => {
	const [t] = useTranslation()
	const dispatch = useDispatch()
	const navigate = useNavigate()

	useEffect(() => {
		Navigator.init(navigate)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		dispatch(getBeVersions())
		dispatch(getIframeVersions())
	}, [dispatch])

	return (
		<RoutesWrapper>
			<Route element={<PublicRoute />}>
				<Route path={t('paths:prihlasenie')} element={<LoginPage />} />
			</Route>
			<Route element={<AuthRoute page={PAGE.FORM_BUILDER} layout={FormBuilderLayout} />}>
				<Route path={t('paths:form-builder/{{templateId}}', { templateId: ':templateId' })} element={<FormBuilderPage page={PAGE.FORM_BUILDER} />} />
			</Route>
			<Route element={<AuthRoute page={PAGE.FORM_PREVIEW} layout={FormBuilderLayout} />}>
				<Route path={t('paths:form-preview/{{templateId}}', { templateId: ':templateId' })} element={<PreviewPage page={PAGE.FORM_BUILDER} />} />
			</Route>
			<Route element={<AuthRoute page={PAGE.SETTINGS} layout={FormBuilderLayout} />}>
				<Route path={t('paths:settings/{{templateId}}', { templateId: ':templateId' })} element={<FormSettingsPage />} />
			</Route>
			<Route element={<AuthRoute page={PAGE.TEMPLATE_BUILDER} layout={FormBuilderLayout} />}>
				<Route
					path={t('paths:template-builder/{{templateId}}', { templateId: ':templateId' })}
					element={<FormBuilderPage page={PAGE.TEMPLATE_BUILDER} />}
				/>
			</Route>
			<Route element={<AuthRoute page={PAGE.TEMPLATE_PREVIEW} layout={FormBuilderLayout} />}>
				<Route
					path={t('paths:template-preview/{{templateId}}', { templateId: ':templateId' })}
					element={<PreviewPage page={PAGE.TEMPLATE_PREVIEW} />}
				/>
			</Route>
			<Route element={<AuthRoute page={PAGE.TEMPLATE_SETTINGS} layout={FormBuilderLayout} />}>
				<Route path={t('paths:template-settings/{{templateId}}', { templateId: ':templateId' })} element={<TemplateSettingsPage />} />
			</Route>
			<Route element={<AuthRoute page={PAGE.FORMS} layout={MainLayout} />}>
				<Route path={t('paths:index')} element={<FormDocsPage />} />
			</Route>
			<Route element={<AuthRoute page={PAGE.FORMS} layout={MainLayout} />}>
				<Route path={t('paths:forms')} element={<FormDocsPage />} />
			</Route>
			<Route element={<AuthRoute page={PAGE.USERS} layout={MainLayout} />}>
				<Route path={t('paths:users')} element={<UsersPage />} />
			</Route>
			<Route element={<AuthRoute page={PAGE.TEMPLATES} layout={MainLayout} />}>
				<Route path={t('paths:templates')} element={<TemplatesPage />} />
			</Route>
			<Route path={'*'} element={<NotFoundPage />} />
		</RoutesWrapper>
	)
}

export default AppRoutes
